export type MapTool = 'none' | 'add-service-corridor';

export type MapRenderOptions = {
  showAnalysisNumbering: boolean;
  largeBuoys?: boolean;
  activeTool?: MapTool;
};

export type MapFeatureType = 'buoy' | 'gridLine' | 'cage' | 'anchorLine' | 'fleetAnchorLine' | 'serviceCorridorHandler';
export const mapFeature: Record<MapFeatureType, MapFeatureType> = {
  buoy: 'buoy',
  gridLine: 'gridLine',
  cage: 'cage',
  anchorLine: 'anchorLine',
  fleetAnchorLine: 'fleetAnchorLine',
  serviceCorridorHandler: 'serviceCorridorHandler',
} as const;

export type MapFeatureOnClickArgs = {
  type: MapFeatureType;
  id: number;
};
export type OnFeatureClick = (data: MapFeatureOnClickArgs) => void;

export type ServiceCorridorData = {
  direction: 'row' | 'column';
  afterIndex: number;
  buoyPairs: Array<{ fromBuoyId: number; toBuoyId: number }>;
};
export type OnAddServiceCorridor = (data: ServiceCorridorData) => void;
